import styled from 'react-emotion';

const Title = styled.p`
  font-size: 1rem;
  position: relative;
  margin-left: 2rem;
  &:before {
    content: '';
    width: 1.5rem;
    height: 1px;
    background-color: ${props => props.theme.colors.grey};
    display: inline-block;
    position: absolute;
    top: 50%;
    left: -2rem;
  }
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    &:before {
      width: 1.5rem;
      left: -40px;
    }
  }
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    &:before {
      width: 1.5rem;
      left: -35px;
    }
  }
`;

export default Title;
